export const EDIT_DEVICE_MODAL_TITLE = 'Edit Device';
export const SAVE_BUTTON_LABEL = 'Save';
export const CANCEL_BUTTON_LABEL = 'Cancel';
export const EDIT_DEVICE_MODAL_MAX_WIDTH = '1300px';
